export const amoWidget = {
  menu: {
    title: 'Виджеты',
    v1: 'Список',
    settings: 'Настройки'
  },
  breadcrumb: {
    index: 'Виджеты',
    settings: {
      index: 'Настройки AmoCRM'
    },
    users: {
      index: 'Пользователи AmoCRM'
    }
  },
  button: {
    sync_users: 'Синхронизировать пользователей'
  },
  modal: {
    edit: 'Редактировать пользователя'
  },
  users_status_default: 'Конфигурируется. Звонки недоступны',
  users_status: {
    enabled: 'Звонки доступны',
    disabled: 'Выключен. Звонки недоступны'
  },
  page: {
    button: {
      settings: "Настройки"
    }
  },
  users_table: {
    tech_status: 'Технический статус',
    amo_name: 'Имя в AmoCRM',
    amo_login: 'Логин в AmoCRM',
    amo_id: 'ID в AmoCRM',
    sip_login: 'Логин SIP аккаунта',
    sip_account: 'Данные SIP аккаунта',
    sip_password: 'Пароль SIP аккаунта',
    caller_id: 'Caller Id',
    inner_number: 'Номер для входящих',
    queue_name: 'Состоит в очереди',
    queue: 'Очередь'
  },
  settings: {
    account: {
      title: 'Аккаунт',
      description: '',
      settings: {
        main: {
          title: 'Основное',
          description: '',
          children: {
            domain: {
              title: 'Домен',
              description: 'Домен копии amoCRM, которая была подключена к текущему аккаунту Zorra'
            },
            amo_login: {
              title: 'Логин',
              description: 'Логин аккаунта amoCRM, который был подключен к текущему аккаунту Zorra'
            },
            status: {
              title: 'Статус',
              description: ''
            }
          }
        }
      }
    },
    integration_scenarios: {
      title: 'Сценарии интеграции',
      description:
        'Это блок в котором настраиваются действия, которые будут происходить в amoCRM при получении входящего звонка или при совершении исходящего звонка пользователем amoCRM.',
      settings: {
        incoming_unknown: {
          title: 'Входящие звонки с неизвестных номеров',
          description: '',
          children: {
            create_contact: {
              title: 'Создавать контакт',
              description: 'Создать сущность Контакт в amoCRM с номером звонящего клиента'
            },
            create_deal: {
              title: 'Создавать сделку',
              description: 'Создать сущность Сделка в amoCRM с номером звонящего клиента'
            },
            creating_type: {
              title: 'Способ создания',
              description: ''
            }
          }
        },
        incoming_known: {
          title: 'Входящие с известных номеров',
          description: '',
          children: {
            create_deal_if_not_exists: {
              title: 'Создавать сделку, если у контакта нет активных сделок',
              description:
                'Если контакт существует и у него нет открытых сделок нужно создать новую сделку.'
            }
          }
        },
        incoming_missing: {
          title: 'Входящие пропущенные',
          description: '',
          children: {
            create_task: {
              title: 'Создавать задачу',
              description:
                'При получении входящего звонка и отсутствии ответа на него создавать задачу.'
            }
          }
        },
        outgoing_unknown: {
          title: 'Исходящие звонки на неизвестные номера',
          description: '',
          children: {
            create_contact: {
              title: 'Создавать контакт',
              description: 'Создать сущность Контакт в amoCRM с номером звонящего клиента'
            },
            create_deal: {
              title: 'Создавать сделку',
              description: 'Создать сущность Сделка в amoCRM с номером звонящего клиента'
            }
          }
        },
        outgoing_known: {
          title: 'Исходящие звонки на известные номера',
          description: '',
          children: {
            create_deal_if_not_exists: {
              title: 'Создавать сделку, если у контакта нет активных сделок',
              description:
                'Если контакт существует и у него нет открытых сделок нужно создать новую сделку.'
            }
          }
        },
        outgoing_no_response: {
          title: 'Исходящие звонки без ответа',
          description: '',
          children: {
            create_note: {
              title: 'Создавать заметку «не дозвонились»',
              description:
                'При исходящих звонках, если абонент не ответил, должна быть создана заметка: "Не дозвонились до 79164532131"'
            }
          }
        }
      }
    },
    users: {
      title: 'Пользователи',
      description: '',
      settings: []
    },
    webhooks: {
      title: 'Вебхуки',
      description: '',
      settings: []
    },
    additional: {
      title: 'Доп. настройки',
      description: '',
      settings: []
    }
  }
};
